import React from 'react';
import { Column, Text } from '@ydistri/ds';
import { FullPage } from './FullPage';

/**
 * Full-page terminal message (no spinner) - used for states the app cannot recover from on its own,
 * e.g. the account has no project to open. Distinct from {@link LoadingFullPage}, which spins.
 */
const MessageFullPage: React.FC<React.PropsWithChildren<{ text: string }>> = ({
  text,
  children,
}) => (
  <FullPage>
    <Column $gap="1rem" $alignItems="center">
      <Text $size="large" $bold>
        {text}
      </Text>
      {children}
    </Column>
  </FullPage>
);

export default MessageFullPage;
